import logger from "./logger";
import type { UnsubsByPath } from "./types";
import unsubOne from "./unsubOne";

export default function unsubAll(unsubsByPath: UnsubsByPath) {
  const paths = Object.keys(unsubsByPath);
  logger.log("Unsub all", paths.length);

  for (const path of paths) {
    unsubOne(unsubsByPath, path);
  }
}
